export default "__VITE_ASSET__CZiLAO1L__"